import get from 'lodash/get';

export default function getDeliveryLimitDescription(shippingRate) {
  const minDays = get(shippingRate, 'deliveryLimits.min');
  const maxDays = get(shippingRate, 'deliveryLimits.max');

  if (minDays && maxDays) {
    return `${minDays}-${maxDays} business days`;
  }

  return null;
}
